import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderLoggedComponent} from './header-logged/header-logged.component';
import {HeaderNotLoggedComponent} from './header-not-logged/header-not-logged.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {PermissionModule} from '../../shared/permission';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {LoggedLayoutComponent} from './logged-layout/logged-layout.component';
import {NotLoggedLayoutComponent} from './not-logged-layout/not-logged-layout.component';
import {MyProfileComponent} from './my-profile/my-profile.component';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StripeAddCardModule} from './my-profile/stripe-add-card/stripe-add-card.module';
import {StripeAddBankAccountModule} from './my-profile/stripe-add-bank-account/stripe-add-bank-account.module';
import {UploadProfilePictureModule} from './my-profile/upload-profile-picture/upload-profile-picture.module';
import {ButtonModule} from '@ucx/ui-cmp';
import {InputTrimmerModule} from '../shared/modules/input-trimmer/input-trimmer.module';
import {MatCardModule} from '@angular/material/card';
import {NotificationsComponent} from './notifications/notifications/notifications.component';
import {CredentialsSelectModule} from '../../shared/components/credentials-select/credentials-select.module';
import {PortalSelectModule} from '../shared/modules/portal-select/portal-select.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {TooltipModule} from '../shared/modules/tooltip/tooltip.module';

@NgModule({
  declarations: [
    HeaderLoggedComponent,
    HeaderNotLoggedComponent,
    SideMenuComponent,
    LoggedLayoutComponent,
    NotLoggedLayoutComponent,
    MyProfileComponent,
    NotificationsComponent
  ],
    imports: [
        CommonModule,
        MatButtonModule,
        RouterModule,
        MatMenuModule,
        PermissionModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        StripeAddCardModule,
        StripeAddBankAccountModule,
        UploadProfilePictureModule,
        ButtonModule,
        InputTrimmerModule,
        CredentialsSelectModule,
        PortalSelectModule,
        MatDatepickerModule,
        CommonModule,
        MatButtonModule,
        RouterModule,
        MatMenuModule,
        PermissionModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        StripeAddCardModule,
        StripeAddBankAccountModule,
        UploadProfilePictureModule,
        ButtonModule,
        InputTrimmerModule,
        MatCardModule,
        MatSlideToggleModule,
        TooltipModule
    ],
  exports: [
    LoggedLayoutComponent,
    NotLoggedLayoutComponent,
    MyProfileComponent,
    HeaderLoggedComponent
  ]
})
export class LayoutModule {
}
